import React, { useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { Checkbox, Grid, Typography } from "@mui/material";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { getPaymentType } from "../../payments/makePayment/utils";
import { roundToTwoDecimalPlace } from "../utils";
import {
  getChargeTypeDisplayName,
  isMandatoryChargeType,
} from "../chargeTypeMapping";

export const InvoiceTile = ({
  reservationId,
  paymentType,
  paymentDate,
  amount,
  isInvoice,
  invoiceNumber,
  dueAmount,
  handleCheckboxClick,
  onPressTile,
  billNumber,
  paymentNumber,
  transactionNumber,
  invoicePaymentNumber,
  dueDate,
  paymentVersion,
  paymentCode,
  chargeStatusCode,
  locationId,
  chargeTypeCode,
}) => {
  const isMandatory = isMandatoryChargeType(chargeTypeCode);
  const [checkBoxValue, setCheckboxValue] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    if (isMandatory && dueAmount > 0 && chargeStatusCode === "BILLED") {
      setCheckboxValue(true);
      handleCheckboxClick(
        {
          totalAmount: dueAmount,
          billNums: billNumber,
        },
        true,
      );
    }
  }, []);
  const getFormatedDate = (dateToFormat) => {
    return moment(dateToFormat).format("MM/DD/YY");
  };

  const handleCheckBoxClick = () => {
    setCheckboxValue((preVal) => !preVal);
    handleCheckboxClick(
      {
        totalAmount: dueAmount,
        billNums: billNumber,
      },
      !checkBoxValue,
    );
  };

  const handleClickTile = () => {
    const paymentBillDetail = {
      isInvoice,
      paymentNumber,
      transactionNumber,
      amount,
      paymentType,
      paymentDate,
      paymentVersion,
      paymentCode,
    };
    const invoiceBillDetails = {
      isInvoice,
      billNumber,
      invoicePaymentNumber,
      reservationId,
      dueDate,
      locationId,
      chargeStatusCode,
      chargeTypeCode,
      dueAmount,
    };
    if (isInvoice) {
      onPressTile({ ...invoiceBillDetails });
    } else {
      onPressTile({ ...paymentBillDetail });
    }
  };

  return (
    <Box
      display={"flex"}
      justifyContent={"center"}
      marginBottom={isInvoice ? "34px" : "0px"}
    >
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"center"}
        height={55}
        mt={1}
        width={{ xs: "100%", md: "70%" }}
      >
        {isInvoice && (
          <Box flex={1} display={"block"}>
            <Checkbox
              checked={checkBoxValue}
              onChange={() => {
                handleCheckBoxClick();
              }}
              disabled={
                dueAmount <= 0 || chargeStatusCode !== "BILLED" || isMandatory
              }
              sx={
                isMandatory && checkBoxValue
                  ? {
                      "&.Mui-disabled": {
                        color: "primary.main",
                        opacity: 0.8,
                      },
                    }
                  : {}
              }
            />
          </Box>
        )}
        <Grid
          flex={9}
          display={"flex"}
          justifyContent={"space-between"}
          alignItems={"center"}
          onClick={() => handleClickTile()}
          style={{
            border: "1px solid #DADADA",
            borderRadius: "5px",
          }}
        >
          <Box
            flex={2}
            flexDirection={"column"}
            justifyContent={"center"}
            pl={{ xs: 1, sm: 2, md: 3 }}
          >
            <Box>
              <Grid container direction={"row"} alignItems={"center"} gap={1}>
                <Typography color={"black"} fontWeight={"bold"}>
                  {`${
                    isInvoice
                      ? t("pages.payments.text05")
                      : t("pages.payments.text06")
                  } ${isInvoice ? billNumber : paymentNumber}`}
                  {isInvoice && isMandatory && (
                    <span
                      style={{
                        fontSize: "16px",
                        color: "red",
                        padding: "2px 4px",
                        fontWeight: 600,
                      }}
                    >
                      *
                    </span>
                  )}
                </Typography>
              </Grid>
            </Box>
            <Box>
              {isInvoice ? (
                <Grid container direction={"column"}>
                  <Typography style={{ fontSize: "14px" }} color={"#7A7A7A"}>
                    {chargeTypeCode && getChargeTypeDisplayName(chargeTypeCode)}
                  </Typography>
                  <Typography style={{ fontSize: "14px" }} color={"#7A7A7A"}>
                    {`${t("pages.payments.text07")} - ${getFormatedDate(
                      paymentDate,
                    )}`}
                  </Typography>
                </Grid>
              ) : (
                <Grid container direction={"row"}>
                  <Typography style={{ fontSize: "14px" }} color={"#7A7A7A"}>
                    {t("pages.payments.text08")} -{" "}
                  </Typography>
                  <Typography style={{ fontSize: "14px" }} color={"#7A7A7A"}>
                    {getPaymentType(paymentType)}
                  </Typography>
                </Grid>
              )}
            </Box>
          </Box>
          <Box flex={1} mr={1}>
            <Typography color={"black"} fontWeight={"bold"} textAlign={"end"}>
              {`$${roundToTwoDecimalPlace(amount)}`}
            </Typography>
            {isInvoice ? (
              <Grid container direction={"row"} justifyContent={"end"}>
                {dueAmount > 0 ? (
                  <Typography style={{ fontSize: "14px" }} color={"red"}>
                    {`${t("pages.payments.text09")} - $${roundToTwoDecimalPlace(
                      dueAmount,
                    )}`}
                  </Typography>
                ) : (
                  <Typography style={{ fontSize: "14px" }} color={"#6BB700"}>
                    {`${t("pages.payments.text10")} `}
                  </Typography>
                )}
              </Grid>
            ) : (
              <Grid
                container
                direction={"row"}
                justifyContent={"end"}
                alignItems={"center"}
              >
                <Typography color={"#7A7A7A"} fontSize={"12px"}>
                  {getFormatedDate(paymentDate)}
                </Typography>
                <Typography
                  color={"#7A7A7A"}
                  fontSize={"12px"}
                  ml={{ xs: "2px", md: 3 }}
                  mr={{ xs: "2px", md: 3 }}
                >
                  |
                </Typography>
                {paymentCode === "REFUNDIN" ? (
                  <Typography color={"#F79E1B"} fontSize={"12px"}>
                    {`${t("pages.payments.text38")} `}
                  </Typography>
                ) : (
                  <Typography color={"#6BB700"} fontSize={"12px"} pl={3}>
                    {`${t("pages.payments.text10")} `}
                  </Typography>
                )}
              </Grid>
            )}
          </Box>
        </Grid>
      </Box>
    </Box>
  );
};
